import uuidGenerator from './uuidGenerator';

export const findWithUUID = (items, uuid) => items.find((item) => (item.uuid === uuid));

export const indexOfUUID = (items, uuid) => items.findIndex((item) => (item.uuid === uuid));

export const removeItemByUUID = (items, uuid) => items.filter((item) => item.uuid !== uuid);

export const findWithUUIDs = (items, categories, uuids) => {
  const matched = uuids.map((uuid) => categories.filter(
    (category) => findWithUUID(items[category].results, uuid),
  ));
  return [...new Set([].concat(...matched))];
};

export const spliceItemByUUID = (items, uuid) => {
  const index = indexOfUUID(items, uuid);
  const item = (index > -1) ? items[index] : null;

  if (item) {
    items.splice(index, 1);
  }

  return item;
};

export const removeUUIDsFromArray = (items) => (items.map((item) => {
  const copy = { ...item };
  delete copy.uuid;
  return copy;
}));

export const addUUIDsToArray = (items) => (items.map((item) => ({ ...item, uuid: uuidGenerator.generate() })));

export const uniqueByUUID = (items) => items.filter((v, i, a) => a.findIndex((t) => (t.uuid === v.uuid)) === i);

export default {
  generate: uuidGenerator.generate,
};
